'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import H4 from 'UIComponents/elements/headings/H4';
import UIBreakString from 'UIComponents/text/UIBreakString';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewSection from 'marketplace-ui-reviews/components/ReviewSection';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import * as ReviewQuestions from '../../constants/reviews/ReviewQuestions';
import { MINIMUM_SEARCH_LENGTH } from '../../constants/reviews/ReviewsListQueries';
import LegacyReview from '../../records/Review';
import { MARIGOLD_MEDIUM } from 'HubStyleTokens/colors';
import { translateService } from 'marketplace-ui-solutions-core/services/serviceUtils';

const hasContent = answer => {
  const isEmptyArray = Array.isArray(answer) && answer.length === 0;
  return answer && !isEmptyArray;
};

const ReviewBody = ({
  AnswerText,
  review,
  className,
  searchTerm,
  catalogServices,
  reviewType
}) => {
  const content = review instanceof LegacyReview ? review.get('content').toJS() : Object.fromEntries(review.get('content'));
  const customizableKey = reviewType === 'THEME' ? 'customizable_theme' : 'customizable_module';

  const renderReviewSection = question => {
    let answer = content[question];

    if (question === ReviewQuestions.SERVICES && catalogServices) {
      answer = /*#__PURE__*/_jsx(FormattedList, {
        children: answer.map((service, index) => {
          const selectedService = catalogServices.filter(catService => catService.id === service)[0];
          const serviceText = selectedService && translateService(selectedService) || '';
          return index === 0 ? serviceText : serviceText.toLowerCase().replaceAll('hubspot', 'HubSpot');
        })
      });
    } else if (searchTerm && searchTerm.length >= MINIMUM_SEARCH_LENGTH) {
      const regex = new RegExp(`((?=${searchTerm})|(?<=${searchTerm}))`, 'i');
      const splitText = answer.split(regex);
      answer = splitText.map((text, index) => {
        return text.toLowerCase() === searchTerm.toLowerCase() ? /*#__PURE__*/_jsx("span", {
          style: {
            backgroundColor: MARIGOLD_MEDIUM
          },
          children: text
        }, index) : /*#__PURE__*/_jsx("span", {
          children: text
        }, index);
      });
    }

    const textKey = `ecosystemMarketplaceCore.reviews.responses.${question === 'customizable' ? customizableKey : question}`;

    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });

    const AnswerTextComponent = question === ReviewQuestions.TITLE ? H4 : AnswerText;
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: /*#__PURE__*/_jsx(AnswerTextComponent, {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: answer
        })
      })
    }, question);
  };

  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: ReviewQuestions.QuestionOrder.map(question => hasContent(content[question]) && renderReviewSection(question))
  });
};

ReviewBody.propTypes = {
  AnswerText: PropTypes.elementType,
  className: PropTypes.string,
  review: PropTypes.oneOfType([PropTypes.instanceOf(LegacyReview), PropTypes.instanceOf(Review)]).isRequired,
  reviewType: PropTypes.oneOf(Object.values(ReviewTypes)),
  searchTerm: PropTypes.string,
  catalogServices: PropTypes.array.isRequired
};
ReviewBody.defaultProps = {
  AnswerText: 'span'
};
export default ReviewBody;